import { useEffect } from "react";

const VitePressEmbed = () => {

  useEffect(() => {
    const handleMessage = (event: any) => {
      console.log("event", event);
      if (event.data.type === "update-url") {
        const newUrl = event.data.url;
        console.log("new url", event, newUrl);
        window.history.pushState(null, "", "#" + newUrl);
      }
    };
    window.addEventListener("message", handleMessage);

    const hash = window.location.href;

    const iframe = document.querySelector("iframe");
    if (iframe && hash) {
      iframe.onload = () => {
        window.postMessage(
          {
            type: "navigate",
            hash: hash,
          },
          "*"
        );
      };
    }
  }, []);

  return (
    <iframe
      src="/kaihong-developer-documents/kaihongos-guides/document/kaihongos-overview.html" // 替换为你自己的 VitePress 站点的 URL
      style={{ width: "100%", height: "calc(100% - 64px)", border: "none", marginTop: "64px" }}
      title="VitePress Embed"
    />
  );
};

export default VitePressEmbed;
